import { useState, useEffect, useContext } from "react";
import { notify, soloNumero } from "../utils/utils";
import { AuthFetch, AuthFetchOauth,Fetch } from "../services/api";
import { useModal } from './useModal';
// import { useModal } from "../useModal";
import { useSpinner } from "./useSpinner";
import { UserContext } from "../context/provider/UserProvider";
// import { isConstructorDeclaration } from "typescript";
// import { useTipoUsuario } from "./useTipoUsuario";


export const useUsuarios = () => {
    const { stateUser , signOut } = useContext(UserContext);
    const usuarioWebDefault = {
        uid: "",
        cn: "",
        givenName: "",
        apellidoPaterno: "",
        apellidoMaterno: "",
        createdDate: "",
        saldo: "",
        sn: "",
        mail: "",
        mobile: "",
        telephoneNumber: "",
        forcePasswordReset: "",
        photoUrl: ""
    }
    
    const [ usuariosWeb, setUsuariosWeb ] = useState([]);
    const [ usuarioWeb, setUsuarioWeb ] = useState(usuarioWebDefault);
    const [ spinner, mostrarSpinner, ocultarSpinner ] = useSpinner();
    const [ isOpen, openModal, closeModal ] = useModal();
    const [ isOpenModalEliminar, openModalEliminar, closeModalEliminar ] = useModal()
    const [ spinnerBuscandoDNI, setSpinnerBuscandoDNI ] = useState(false)

    const listarUsuariosWeb = async () => {
        mostrarSpinner();
        try{
            const response = await AuthFetch('/User/userLdapManager')
            !response.isValid && notify(response.exceptions[0].description, 'error' )
            if (response.isValid) {
                setUsuariosWeb(response.content)
            }
            ocultarSpinner();
        }
        catch(error)
        {
            ocultarSpinner();
        }
        
    }

    // const listarUsuariosApp = async (codEstado) => {
    //     mostrarSpinner();
    //     const response = await AuthFetch('/User?' + new URLSearchParams({
    //         codEstado: codEstado,
    //     }), {
    //         method: 'GET'
    //     })
    //     if (response.isValid) {
    //         setUsuarios(response.content)
    //     } else {
    //         notify(response.exceptions[0].description, 'error')
    //     }
    //     ocultarSpinner()
    // }

    // const obtenerUsuario = async (data) => {
    //     if(data){
            
    //     }
    //     else{

    //     }
    // }

    const cargarDatosPorDNI = async () => {
        setSpinnerBuscandoDNI(true)
        const response = await Fetch({url :'https://identidadwebapi.abexacloud.com/api/Identidad/obtenerDni?'+ new URLSearchParams({dni: usuarioWeb.dni,}),})

        if(response.isValid){
            const usuarioMostrar = {
                codPersona: 0,
                nombre: response.content.nombres,
                apellidos: response.content.apellidoPaterno + ' ' + response.content.apellidoMaterno,
                codDocumentoTipo: 1,
                dni: response.content.dni,

                telefonoActual:'',
                codUsuarioAccion:0,
                codEstado:0,
                motivoEliminacion:'',
                nomEstado:''
            }
            setUsuarioWeb(usuarioMostrar)
        }else{
            // setUsuario(usuarioDefault)
            notify('Error al traer datos por DNI','error');
        }
        setSpinnerBuscandoDNI(false)
    }




    // const usuarioEliminar = async (codUsuario) =>{
    //     if (codUsuario) {
    //         const response = await AuthFetch('​/User​/obtenerUsuarioPorCodUsuario?' + new URLSearchParams({
    //             CodUsuario : codUsuario
    //         }))
    //         if (response.isValid) {
    //             setUsuario(response.content);
    //         } else {
    //             notify(response.exceptions[0].description, 'error');
    //         }
    //     } else {
    //         setUsuario(usuarioDefault);
    //     }
    //     openModalEliminar();
    // }

    // const eliminarUsuario = async ()=>{
    //     const response = await AuthFetchOauth('/api/Manager/eliminarUsuario',{
    //         method:'POST',
    //         body: JSON.stringify({
    //             codUsuario: usuario.codUsuario,
    //             codUsuarioAccion: 1,
    //             motivo: usuario.motivo
    //         })
    //     })
    //     notify(response.isValid ? 'Se elimino el usuario Correctamente' : response.exceptions[0].description, response.isValid ? 'success' : 'error')
    //     if (response.isValid) {
    //         // listarUsuarios()
    //     }
    //     closeModalEliminar()
    // }

    // const guardarEditarUsuario = async () => {
    //     if (usuario.codPersona === 0 || usuario.codUsuarioTipo === 0 || usuario.nomUsuario === ''  ||  usuario.claveUsuario === ''){
    //         notify('Debe ingresar los parametros correctamente','error')
    //         return;
    //     } 
        
    //     const response = await AuthFetch('/registerWebUser', {
    //         method:'POST', 
    //         body: JSON.stringify({
    //             nombreUsuario: usuario.nombreUsuario,
    //             nombreComun: usuario.nombreComun,
    //             dni: usuario.dni,
    //             nombre: usuario.nombre,
    //             apellidos: usuario.apellidos,
    //             correoElectronico: usuario.correoElectronico,
    //             telefono: usuario.telefono,
    //             rol: [
    //                 usuario.rol
    //             ],
    //             clave: usuario.clave
    //         })
    //     });
    //     notify(response.content,(response.isValid ? 'success' : 'error'));
    //     if (response.isValid){
    //         setUsuario(usuarioDefault);
    //         await listarUsuariosWeb();
    //     }
    //     closeModal();
    // }
    
    // const editarValorUsuario = (key,value) =>{
    //     setUsuario(usuario => {
    //         return {
    //             ...usuario,
    //             [key]: value
    //         }
    //     });
    // }  

    return {
        usuariosWeb,
        listarUsuariosWeb,
        usuarioWeb,
        // editarValorUsuario,
        // obtenerUsuario,
        // spinner,
        // isOpen,
        // closeModal,
        // isOpenModalEliminar,
        // closeModalEliminar,
        // guardarEditarUsuario,
        // usuarioEliminar,
        // eliminarUsuario,
        cargarDatosPorDNI,
        spinnerBuscandoDNI
     };
}